import React, { useState } from 'react';
import { Formik } from 'formik';
import { Col, Row, Form } from 'react-bootstrap';
import * as yup from 'yup';
import { CustomButton } from '../../../../shared/customButton';
import CustomDropZone from '../../../../shared/customDropZone';
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomTextArea} from '../../../../shared/customTextArea'

import styles from './sendOfferConfigurations.module.scss';

// Schema for File Upload (type 10)
const fileUploadSchema = yup.object().shape({
    name: yup.string().required('Document name is required'),
    type: yup.number().oneOf([10], 'Invalid document type').required('Document type is required'),
    file: yup.mixed()
        .required('File is required when type is "Upload File"'),
    link: yup.string().notRequired(),
    is_sign_required: yup.boolean(),
});

// Schema for External Link (type 20)
const externalLinkSchema = yup.object().shape({
    name: yup.string().required('Document name is required'),
    type: yup.number().oneOf([20], 'Invalid document type').required('Document type is required'),
    file: yup.mixed().notRequired(),
    link: yup.string()
        .required('Document link is required when type is "External Link"')
        .matches(/^(http|https):\/\/[^ "]+$/, 'Invalid URL. Must start with  http://, or https://'),
    is_sign_required: yup.boolean(),
});

// Function to get the appropriate schema based on type
const getDocumentSchema = (type) => {
    return type === 10 ? fileUploadSchema : externalLinkSchema;
};

// Validation schema for the whole form
const validationSchema = yup.object().shape({
    documents: yup.array()
      .of(
        yup.lazy(value => getDocumentSchema(value.type))
      )
      .min(1, 'At least one document is required')  // Ensure at least one document is present
  });

const SendOfferConfigurations = (props) => {
    const [documents, setDocuments] = useState(props.values.documents || []);

    /// On submit function
    const onSubmit = async (values) => {
        props.updateValues({ documents: values.documents });
        props.nextPage(2);
    };

    const handleAddDocument = (values, setFieldValue) => {
        if (!values.documents.length || values.documents.every(doc => doc.name && (doc.type === 10 ? doc.file : doc.link))) {
            const updatedDocuments = values.documents.map(doc => ({ ...doc, saved: true }));
            const newDocument = {
                type: 10,
                name: '',
                link: '',
                file: null,
                is_sign_required: false,
                saved: false,
            };
            setFieldValue('documents', [...updatedDocuments, newDocument]);
        }
    };


    // Removing a document
    const handleRemoveDocument = (index, values, setFieldValue) => {
        const updatedDocuments = values.documents.filter((_, i) => i !== index);
        setFieldValue('documents', updatedDocuments);
    };
    //Edit document 
    const handleEditDocument = (index, values, setFieldValue) => {
        const updatedDocuments = values.documents.map((doc, i) =>
            i === index ? { ...doc, saved: false } : doc
        );
        setFieldValue('documents', updatedDocuments);
    };

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                initialValues={{ documents }}
            >
                {({
                    errors,
                    values,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    submitCount,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        {values.documents.map((doc, index) => (
                            <div key={index} className={errors.documents && errors.documents[index]? styles.documentErro : styles.documentItem}>
                                {doc.saved && !(errors.documents && errors.documents[index])? (
                                    <div>
                                        <Col className={styles.nameAndDleteEditRow} >
                                            <Row>
                                                <p className={styles.displyBoxMainText}>{doc.name}&nbsp;<span className={styles.radioBtnSubText}>{doc.is_sign_required ? '(Candidate required to Sign)' : ''}</span></p>
                                            </Row>
                                            <Row>
                                                <Col className={styles.BtnRow}>
                                                    <Row>
                                                        <div
                                                            className={styles.EditBtn}
                                                            onClick={() => handleEditDocument(index, values, setFieldValue)}
                                                            style={{ cursor: 'pointer' }} // Ensures the cursor changes to a pointer on hover
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                <g clipPath="url(#clip0_3929_6825)">
                                                                    <path d="M9.1665 3.3332H5.6665C4.26637 3.3332 3.56631 3.3332 3.03153 3.60568C2.56112 3.84536 2.17867 4.22782 1.93899 4.69822C1.6665 5.233 1.6665 5.93307 1.6665 7.3332V14.3332C1.6665 15.7333 1.6665 16.4334 1.93899 16.9682C2.17867 17.4386 2.56112 17.821 3.03153 18.0607C3.56631 18.3332 4.26637 18.3332 5.6665 18.3332H12.6665C14.0666 18.3332 14.7667 18.3332 15.3015 18.0607C15.7719 17.821 16.1543 17.4386 16.394 16.9682C16.6665 16.4334 16.6665 15.7333 16.6665 14.3332V10.8332M6.66648 13.3332H8.06193C8.46959 13.3332 8.67341 13.3332 8.86522 13.2871C9.03528 13.2463 9.19786 13.179 9.34698 13.0876C9.51517 12.9845 9.6593 12.8404 9.94755 12.5521L17.9165 4.5832C18.6069 3.89284 18.6069 2.77355 17.9165 2.0832C17.2261 1.39284 16.1069 1.39284 15.4165 2.0832L7.44753 10.0521C7.15928 10.3404 7.01515 10.4845 6.91208 10.6527C6.8207 10.8018 6.75336 10.9644 6.71253 11.1345C6.66648 11.3263 6.66648 11.5301 6.66648 11.9378V13.3332Z"
                                                                        strokeWidth="1.66667"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_3929_6825">
                                                                        <rect width="20" height="20" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </div>

                                                    </Row>
                                                    <Row className={styles.dleteBtnRow}>
                                                        <div
                                                            onClick={() => handleRemoveDocument(index, values, setFieldValue)}
                                                            className={styles.questionDeleteIcon}>
                                                            <svg

                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="22"
                                                                height="23"
                                                                viewBox="0 0 22 23"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M15.4444 5.5V4.7C15.4444 3.5799 15.4444 3.01984 15.2022 2.59202C14.9892 2.21569 14.6492 1.90973 14.2311 1.71799C13.7557 1.5 13.1335 1.5 11.8889 1.5H10.1111C8.86655 1.5 8.24427 1.5 7.76891 1.71799C7.35077 1.90973 7.01082 2.21569 6.79776 2.59202C6.55556 3.01984 6.55556 3.5799 6.55556 4.7V5.5M8.77778 11V16M13.2222 11V16M1 5.5H21M18.7778 5.5V16.7C18.7778 18.3802 18.7778 19.2202 18.4145 19.862C18.0949 20.4265 17.585 20.8854 16.9577 21.173C16.2447 21.5 15.3113 21.5 13.4444 21.5H8.55556C6.68871 21.5 5.75529 21.5 5.04225 21.173C4.41505 20.8854 3.90511 20.4265 3.58553 19.862C3.22222 19.2202 3.22222 18.3802 3.22222 16.7V5.5"
                                                                    stroke="#B42318"
                                                                    strokeWidth="1.5"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        {doc.type === 20 && (
                                            <a className={styles.linkText} href={doc.link} target="_blank" rel="noopener noreferrer">
                                                {doc.link}
                                            </a>
                                        )}
                                    </div>) : (
                                    <>
                                        <Col className={styles.nameAndDleteRow}>
                                            <Row>
                                                <p className={styles.documentTitleText}>Document Name</p>
                                            </Row>
                                            <Row className={styles.dleteBtnRow}>
                                                <div
                                                onClick={() => handleRemoveDocument(index, values, setFieldValue)}
                                                className={styles.questionDeleteIcon}>
                                                <svg

                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="22"
                                                    height="23"
                                                    viewBox="0 0 22 23"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M15.4444 5.5V4.7C15.4444 3.5799 15.4444 3.01984 15.2022 2.59202C14.9892 2.21569 14.6492 1.90973 14.2311 1.71799C13.7557 1.5 13.1335 1.5 11.8889 1.5H10.1111C8.86655 1.5 8.24427 1.5 7.76891 1.71799C7.35077 1.90973 7.01082 2.21569 6.79776 2.59202C6.55556 3.01984 6.55556 3.5799 6.55556 4.7V5.5M8.77778 11V16M13.2222 11V16M1 5.5H21M18.7778 5.5V16.7C18.7778 18.3802 18.7778 19.2202 18.4145 19.862C18.0949 20.4265 17.585 20.8854 16.9577 21.173C16.2447 21.5 15.3113 21.5 13.4444 21.5H8.55556C6.68871 21.5 5.75529 21.5 5.04225 21.173C4.41505 20.8854 3.90511 20.4265 3.58553 19.862C3.22222 19.2202 3.22222 18.3802 3.22222 16.7V5.5"
                                                        stroke="#B42318"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                            </Row>
                                        </Col>
                                        <CustomTextField
                                            classLabel="defaultLabel"
                                            controlId={`documents[${index}].name`}
                                            type="text"
                                            value={doc.name}
                                            name={`documents[${index}].name`}
                                            classType="defaultTextBox"
                                            handleOnChange={handleChange}
                                            maxlength={100}
                                            errorMessage={errors.documents && errors.documents[index] && errors.documents[index].name}
                                            isInvalid={submitCount > 0 && !!(errors.documents && errors.documents[index] && errors.documents[index].name)}
                                        />

                                        <Col className={styles.radioButtonFlex}>
                                            <Row>
                                                <Form.Check
                                                    type="radio"
                                                    name={`documents[${index}].type`}
                                                    value="10"
                                                    checked={doc.type === 10}
                                                    onChange={() => {
                                                        const updatedDocuments = [...values.documents];
                                                        updatedDocuments[index].type = 10;
                                                        setFieldValue('documents', updatedDocuments);
                                                    }}
                                                    label={<p className={styles.radioBtnMainText}>Upload File&nbsp;<span className={styles.radioBtnSubText}>(PDF Only)</span></p>}
                                                />
                                            </Row>
                                            <Row>
                                                <Form.Check
                                                    type="radio"
                                                    name={`documents[${index}].type`}
                                                    value="20"
                                                    checked={doc.type === 20}
                                                    onChange={() => {
                                                        const updatedDocuments = [...values.documents];
                                                        updatedDocuments[index].type = 20;
                                                        setFieldValue('documents', updatedDocuments);
                                                    }}
                                                    label={<p className={styles.radioBtnMainText}>External Document Link</p>}
                                                />
                                            </Row>
                                        </Col>
                                        {doc.type === 10 && (
                                            <CustomDropZone
                                                selectedFile={doc.file ? doc.file.name : ''}
                                                classLabel="defaultLabel"
                                                isMultiUpload={false}
                                                isImageUpload={false}
                                                maxFileSize={5242880}
                                                acceptFileTypes="application/pdf"
                                                viewBoxIcon={
                                                    <svg width="62" height="51" viewBox="0 0 62 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M31 25.5V44.625" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M52.6739 39.0789C55.1936 37.949 57.184 36.161 58.3311 33.9972C59.4782 31.8334 59.7167 29.417 59.0088 27.1294C58.301 24.8417 56.6871 22.8131 54.422 21.3637C52.1569 19.9143 49.3695 19.1267 46.4998 19.1251H43.2448C42.4628 16.6373 41.0054 14.3276 38.9821 12.3698C36.9588 10.4119 34.4223 8.85683 31.5632 7.82144C28.7041 6.78605 25.5969 6.29729 22.4751 6.3919C19.3533 6.48651 16.2982 7.16204 13.5395 8.36769C10.7808 9.57334 8.39021 11.2777 6.54755 13.3528C4.70488 15.4278 3.45806 17.8194 2.90081 20.3479C2.34356 22.8763 2.49038 25.4758 3.33024 27.9508C4.17011 30.4259 5.68115 32.7121 7.74978 34.6376" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M41.3332 34L30.9998 25.5L20.6665 34" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                                uploadFileTopic="Drag and Drop or Click to select file"
                                                maximumFileSizeInMBLabel="5"
                                                updatedDocuments = {[...values.documents]}
                                                index={index}
                                                arrayName={'documents'}
                                                isAddArry={true}
                                                setFieldValue={setFieldValue}
                                                name={`documents[${index}].file`}
                                                errorMessage={submitCount > 0 && errors.documents && errors.documents[index] && errors.documents[index].file}
                                                isInvalid={submitCount > 0 && !!(errors.documents && errors.documents[index] && errors.documents[index].file)}
                                            />
                                        )}
                                        {doc.type === 20 && (
                                            <div className={styles.customTextAreaDiv}>
                                            <CustomTextArea
                                             rowCount={3}
                                             values={doc.link}
                                             handleChange={handleChange}
                                             errorMessage={errors.documents && errors.documents[index] && errors.documents[index].link}
                                             isInvalid={submitCount > 0 && !!(errors.documents && errors.documents[index] && errors.documents[index].link)}
                                             controlId={`documents[${index}].link`}
                                             name={`documents[${index}].link`}
                                             />
                                             </div>
                                        )}
                                        <Form.Check
                                            type="checkbox"
                                            label="Candidate required to Sign"
                                            name={`documents[${index}].is_sign_required`}
                                            checked={doc.is_sign_required}
                                            onChange={() => {
                                                const updatedDocuments = [...values.documents];
                                                updatedDocuments[index].is_sign_required = !doc.is_sign_required;
                                                setFieldValue('documents', updatedDocuments);
                                            }}
                                            className={styles.defaultCheckBox}
                                        />
                                    </>)
                                }
                            </div>

                        ))}
                        <div className="mt-4 mb-3">
                            <CustomButton
                                id="add_documents"
                                buttonType="button"
                                label="Add Document"
                                type="secondaryBtn"
                                frontIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <g clipPath="url(#clip0_2101_3258)">
                                            <path d="M10.4998 4.1665V15.8332M4.6665 9.99984H16.3332" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2101_3258">
                                                <rect width="20" height="20" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                }
                                handleClick={(e) => handleAddDocument(values, setFieldValue)}
                            />
                        </div>
                        <div className='d-flex flex-row-reverse'>
                        <div className={styles.navigateBtnCol}>
                            <CustomButton
                                buttonType="submit"
                                label="Review"
                                type="primaryBtn"
                            />
                        </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default SendOfferConfigurations;
